import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import ResumenDiario from './resumen';

class PortadaView extends React.Component {

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Portada</h3>
                    </Col>
                    <ResumenDiario/>
                </Row>
            </Container>
        );
    }
}

export default PortadaView;



// WEBPACK FOOTER //
// ./src/components/pages/portada/portada.tsx